var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Exclude, Expose, Type } from 'class-transformer';
import { IsArray, IsBoolean, IsDateString, IsEnum, IsNumber, IsOptional, IsString, IsUUID, } from 'class-validator';
import { Role } from '../../roles/index.js';
import { Difficulty } from '../enums/difficulty.enum.js';
import { Visibility } from '../enums/visibility.enum.js';
import { BodyRegionFullSizeDto } from './body-region.full-size.dto.js';
import { ExercisePackageFullSizeDto } from './exercise-package.full-size.dto.js';
export class ExerciseLiteDto {
    id;
    createdAt;
    updatedAt;
    title;
    filename;
    thumbFilename;
    originalFilename;
    shotNo;
    text;
    indication;
    duration;
    deviceText;
    weightNeeded;
    difficulty;
    visibility;
    exercisePackages;
    bodyRegions;
    positiveRatingCount;
    negativeRatingCount;
    avgRating;
    uploadedById;
    sharedWithUserId;
    sharedWithOfficeId;
}
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], ExerciseLiteDto.prototype, "id", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Date)
], ExerciseLiteDto.prototype, "createdAt", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Date)
], ExerciseLiteDto.prototype, "updatedAt", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], ExerciseLiteDto.prototype, "title", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], ExerciseLiteDto.prototype, "filename", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], ExerciseLiteDto.prototype, "thumbFilename", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Exclude(),
    __metadata("design:type", Object)
], ExerciseLiteDto.prototype, "originalFilename", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], ExerciseLiteDto.prototype, "shotNo", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], ExerciseLiteDto.prototype, "text", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], ExerciseLiteDto.prototype, "indication", void 0);
__decorate([
    IsNumber(),
    Expose(),
    __metadata("design:type", Number)
], ExerciseLiteDto.prototype, "duration", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], ExerciseLiteDto.prototype, "deviceText", void 0);
__decorate([
    IsBoolean(),
    Expose(),
    __metadata("design:type", Boolean)
], ExerciseLiteDto.prototype, "weightNeeded", void 0);
__decorate([
    IsEnum(Difficulty),
    Expose(),
    __metadata("design:type", String)
], ExerciseLiteDto.prototype, "difficulty", void 0);
__decorate([
    IsEnum(Visibility),
    Expose(),
    __metadata("design:type", String)
], ExerciseLiteDto.prototype, "visibility", void 0);
__decorate([
    IsArray(),
    Type(() => ExercisePackageFullSizeDto),
    Expose(),
    __metadata("design:type", Array)
], ExerciseLiteDto.prototype, "exercisePackages", void 0);
__decorate([
    IsArray(),
    Type(() => BodyRegionFullSizeDto),
    Expose(),
    __metadata("design:type", Array)
], ExerciseLiteDto.prototype, "bodyRegions", void 0);
__decorate([
    IsNumber(),
    Expose(),
    __metadata("design:type", Number)
], ExerciseLiteDto.prototype, "positiveRatingCount", void 0);
__decorate([
    IsNumber(),
    Expose(),
    __metadata("design:type", Number)
], ExerciseLiteDto.prototype, "negativeRatingCount", void 0);
__decorate([
    IsNumber(),
    Expose(),
    __metadata("design:type", Number)
], ExerciseLiteDto.prototype, "avgRating", void 0);
__decorate([
    IsUUID(),
    Expose({ groups: [Role.THERAPIST, Role.ADMIN, Role.MANAGEMENT] }),
    __metadata("design:type", Object)
], ExerciseLiteDto.prototype, "uploadedById", void 0);
__decorate([
    IsUUID(),
    Exclude(),
    __metadata("design:type", Object)
], ExerciseLiteDto.prototype, "sharedWithUserId", void 0);
__decorate([
    IsUUID(),
    Exclude(),
    __metadata("design:type", Object)
], ExerciseLiteDto.prototype, "sharedWithOfficeId", void 0);
//# sourceMappingURL=exercise.lite.dto.js.map